import Footer from './Footer'
import Main from './Main'
import Movies from './Movies'
import Search from './Search'

const Home = () => {

    
  return (
    <div>
        <Main />
        <Search />
        <Movies />
        <Footer />
    </div>
  )
}

export default Home